import { useTranslation } from 'react-i18next';

import cn from 'classnames';

export type FooterColumns = {
  title?: string;
  links?: {
    url: string;
    text: string;
  }[];
};

export type FooterProps = {
  footerColumns?: FooterColumns[];
  footerContent?: string[];
};

const styles = {
  root: 'bg-neutral-300 pt-8 pb-10 flex flex-col justify-center border-b-8 border-primary-600',
  container: 'mx-auto w-11/12 sm:w-9/12 xl:max-w-container',
  nav: 'grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-8 mb-6',
  h5: 'mb-6',
  p: 'text-sm leading-6 mb-4',
  li: 'first:mt-0 mt-4',
  a: 'text-sm font-bold text-neutral-800 hover:text-neutral-900 active:opacity-70 visited:text-[#452c7d]'
};

export const Footer = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'common' });

  const footerColumns = t('footer.columns', { returnObjects: true }) as FooterColumns[];
  const footerContent = t('footer.text', { returnObjects: true, replace: { year: new Date().getFullYear() } }) as string[];

  const transformedFooterColumns = footerColumns?.map((i) => ({
    ...i,
    links: i.links?.map((link) => ({ ...link, url: link.url }))
  }));

  return (
    <footer className={cn(styles.root)}>
      <div className={cn(styles.container)}>
        <nav className={cn(styles.nav)}>
          {transformedFooterColumns &&
            transformedFooterColumns.map((section, index) => (
              <div key={index}>
                {section.title && section.title.length > 0 && <h5 className={cn(styles.h5)}>{section.title}</h5>}
                {section.links && section.links.length > 0 && (
                  <ul>
                    {section.links.map((link, linkIndex) => (
                      <li key={linkIndex} className={cn(styles.li)}>
                        <a target='_blank' href={link.url} className={cn(styles.a)}>
                          {link.text}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
        </nav>
        {footerContent &&
          footerContent.map((content, index) => (
            <p key={index} className={cn(styles.p)}>
              {content}
            </p>
          ))}
      </div>
    </footer>
  );
};

export default Footer;
